<script setup>
  import { useRouter } from "vue-router";
  import { ref } from "vue";
  import { signIn } from "@/firebase/firebase";

  const router = useRouter();
  const form = ref(false);
  const email = ref(null);
  const password = ref(null);
  const loading = ref(false);
  const required = function (v) {
    return !!v || "Field is required";
  };

  const onSubmit = async function () {
    if (form.value == false) return;
    try {
      const user = await signIn(email.value, password.value);
      if (user) {
        router.push({ name: "createCoupon" });
      } else {
        loading.value = false;
        alert("認証に失敗しました");
      }
    } catch {
      loading.value = false;
      alert("認証に失敗しました");
    }
  };
</script>

<template>
  <div class="mt-13 mx-auto">
    <v-card class="mx-auto px-6 py-8" max-width="800">
      <v-form v-model="form" @submit.prevent="onSubmit">
        <v-text-field :rules="[required]" v-model="email" type="email" autocomplete label="メールアドレス" />
        <v-text-field :rules="[required]" v-model="password" type="password" label="パスワード" />
        <v-btn :disabled="!form" :loading="loading" class="mt-5" block color="blue" size="large" type="submit"
          variant="elevated" @click="loading = true">
          ログイン
        </v-btn>
      </v-form>
    </v-card>
  </div>
</template>
